<script>
import FAQ from "@/utils/FAQ.json";
import Modal from "@/components/_Shared/Modal";

export default {
  categories: FAQ,
  components: {
    Modal
  },
  data() {
    return {
      showQuestion: false,
      question: null
    };
  },
  methods: {
    openQuestion(question) {
      this.question = question;
      this.showQuestion = true;
    }
  }
};
</script>

<template>
  <div class="card">
    <h1 class="title text-center">PERGUNTAS FREQUENTES</h1>

    <ul v-for="(category, index) in $options.categories" :key="index">
      <div>{{category.name}}</div>
      <li
        v-for="(question, index) in category.questions"
        :key="index"
        @click="openQuestion(question)"
      >{{question.question}}</li>
    </ul>

    <modal
      v-if="showQuestion && question"
      :title="question.question"
      subtitle
      size="md"
      @close="showQuestion = false"
    >
      <template slot="body">
        <div style="font-size: 14px !important; line-height: 20px;" v-html="question.answer"></div>
      </template>
      <template slot="footer">
        <button class="btn bg-purple-outline" @click="showQuestion = false">fechar</button>
      </template>
    </modal>
  </div>
</template>

<style scoped>
ul {
  padding-left: 0;
  list-style: none;
  font-size: 13px;
  margin-bottom: 10px;
}

ul div {
  color: var(--pink);
  font-weight: 500;
  margin-bottom: 10px;
}

ul li {
  margin: 3px 0 3px 8px;
  cursor: pointer;
  transition: all 0.25s ease;
}

ul li:hover {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Questions.vue